function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { ListingType } from '@domain-group/fe-allhomes-library';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import Selector from '../selector/selector';
import sortOptions, { DEFAULT_SORT } from './sort-options';
import * as styles from './allhomes-search-sorting-tablet.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesSearchSortingTablet extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onSelect", value => {
      if (this.dropdownRef && this.dropdownRef.ensureClosed) {
        this.dropdownRef.ensureClosed();
      }
      this.props.onSelect(value);
    });
    _defineProperty(this, "setDropdownRef", ref => {
      this.dropdownRef = ref;
    });
  }
  render() {
    return ___EmotionJSX(Dropdown, {
      align: this.props.align,
      ref: this.setDropdownRef,
      title: "Sort",
      css: styles.container,
      anchorClass: "sorting-tablet-anchor",
      hasIcon: true
    }, ___EmotionJSX(Selector, {
      options: sortOptions(this.props.listingType),
      selectedValue: this.props.value,
      onSelect: this.onSelect
    }));
  }
}
AllhomesSearchSortingTablet.propTypes = {
  align: PropTypes.string,
  listingType: PropTypes.string,
  value: PropTypes.string,
  onSelect: PropTypes.func
};
AllhomesSearchSortingTablet.defaultProps = {
  align: undefined,
  listingType: ListingType.SALES_RESIDENTIAL.name,
  value: DEFAULT_SORT,
  onSelect: () => {}
};
export default AllhomesSearchSortingTablet;